/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiSlice } from "../http";
import { Tags } from "@/enum/tags";

interface Transaction {
    Empresa: string
    Loja: string
    "Nome Loja": string
    CNPJ: string
    PDV: string
    "Data/Hora": string
    NSU: string
    Cupom: string
    Rede: string
    Cartão: string
    Transação: string
    Valor: string
    Ação: string
    Status: string
}

interface ScanData {
    scan: Transaction[]
    scanned_by: string
    scanned_at: string
    excelBase64: string
}

interface ApiResponse {
    data: ScanData[]
    meta: {
        total: number
        lastPage: number
        currentPage: number
        perPage: number
        prev: null | number
        next: null | number
    }
}

export interface ValidationHistoryEvent {
    id: number
    entity_type: string
    entity_id: string
    event_type: string
    event_payload: {
        total_items?: number
        successful?: number
        failed?: number
        metadata?: {
            fileName?: string
            rowCount?: number
            found?: number
            notFound?: number
            scannedBy?: string
        }
    }
    email: string
    created_at: string
}

export interface ValidationHistoryResponse {
    data: ValidationHistoryEvent[]
    pagination: {
        page: number
        limit: number
        total: number
        totalPages: number
    }
}

export interface ValidationHistoryQuery {
    page?: number
    limit?: number
    dateFrom?: string
    dateTo?: string
    actorEmail?: string
    fileName?: string
}

export const dtefScanApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        generateScan: builder.mutation<ApiResponse, { file: File }>({
            query: ({ file }) => {
                const formData = new FormData();
                formData.append("file", file);

                return {
                    url: `/dtef`,
                    method: "POST",
                    body: formData,
                };
            },
            invalidatesTags: [Tags.DTEF],
        }),

        getValidationHistory: builder.query<ValidationHistoryResponse, ValidationHistoryQuery>({
            query: ({ page = 1, limit = 10, dateFrom, dateTo, actorEmail, fileName }) => {
                const params = new URLSearchParams({
                    page: String(page),
                    limit: String(limit),
                });
                if (dateFrom) params.append("date_from", dateFrom);
                if (dateTo) params.append("date_to", dateTo);
                if (actorEmail) params.append("actor_email", actorEmail);
                if (fileName) params.append("file_name", fileName);
                return {
                    url: `/dtef/validation-history?${params.toString()}`,
                    method: "GET",
                };
            },
            providesTags: [Tags.DTEF],
        }),

    }),
});

export const {
    useGenerateScanMutation,
    useGetValidationHistoryQuery,
} = dtefScanApi;
